<template>
  <div
    class="template-preview"
    :class="{ 'template-preview --loading': !templateData }"
  >
    <TemplateDetails
      class="flex-none"
      :templateData="templateData"
      v-if="templateData"
      :templateLocation="templateLocation"
    />
    <TemplateSlides
      class="flex-grow"
      :isPopupMode="isPopupMode"
      :slides="templateData.Slides"
      v-if="templateData"
    />
    <InlineLoader v-else additionalClasses="logo-loader" />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'

import InlineLoader from '@/components-v2/common/loading/InlineLoader.vue'
import TemplateDetails from './TemplateDetails.vue'
import TemplateSlides from './TemplateSlides.vue'
import ApiPresentation from '@/api/presentation'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'

export default {
  components: {
    TemplateDetails,
    TemplateSlides,
    InlineLoader,
  },
  props: {
    presentationShareCode: {
      type: String,
      required: false,
      default: '',
    },
    isPopupMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    templateLocation: {
      type: String,
      default: null,
    },
    where: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      templateData: null,
    }
  },
  async mounted() {
    let shareCode
    if (!this.presentationShareCode) {
      shareCode = this.$route.params.shareCode
    }
    await this.getPresentationTemplateDetail(shareCode)
    if (this.templateData) {
      this.track()
    }
    EventBus.$on('update-template-preview-after-published', (template) => {
      this.templateData.name = template.name
      this.templateData.description = template.description
      if (template.customThumbnailImage !== '_blank') {
        this.templateData.customThumbnailImage = template.customThumbnailImage
      }
      if (template.categoryIds) { // categories modal in template library
        const presentationsCategories = template.categoryIds.map((item) => {
          return {
            categoryId: item,
            presentationId: this.templateData.id,
          }
        })
        this.templateData.PresentationsCategories = presentationsCategories
      }
    })
  },
  destroyed() {
    EventBus.$off('update-template-preview-after-published')
  },

  methods: {
    track() {
      const TEMPLATE_LIBRARY = 'Template library'
      let trigger = this.templateLocation === 'top panel' ? 'Presentation list' : TEMPLATE_LIBRARY
      if (trigger === TEMPLATE_LIBRARY && this.where) {
        trigger = this.where
      }
      Utils.mixpanelTracking(eventCategories.TEMPLATE_LIBRARY, 'Preview template', trigger, this.templateData.id)
    },
    async getPresentationTemplateDetail(shareCode) {
      try {
        const resp =
          await ApiPresentation.getPresentationSharing(shareCode || this.presentationShareCode)
        resp.Slides.sort((a, b) => {
          return a.order - b.order
        })
        resp.Slides.forEach((item) => {
          item.typeAnswerOptions = []
          if (item.correctQuizTypeAnswer) {
            item.typeAnswerOptions.push({
              index: null,
              title: item.correctQuizTypeAnswer,
            })
          }
          if (item.otherCorrectQuiz) {
            item.typeAnswerOptions =
              item.typeAnswerOptions.concat(JSON.parse(item.otherCorrectQuiz))
          }
        })
        this.templateData = resp
      } catch {
        Sentry.captureException({
          error: 'template preview',
          shareCode,
          presentationShareCode: this.presentationShareCode,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.template-preview {
  position: relative;
  min-height: 300px;
  @apply flex flex-col bg-base-0 md:flex-row;
  @apply items-center md:items-start;

  @media screen and (max-width: 767px) {
    padding-top: 30px;
    height: 100vh;
  }

  &.--loading {
    @apply items-center justify-center;
  }

}
.logo-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}
</style>
